import { type RootState } from '../store';

export const selectBookingId = (state: RootState) => state.booking.booking?.id;
export const selectBooking = (state: RootState) => state.booking.booking;
export const selectProcessIdFromBooking = (state: RootState) => state.booking.booking?.processId;
export const selectProcessFromBooking = (state: RootState) => state.booking.booking?.process;
export const selectOnContinueWithBooking = (state: RootState) => state.booking.onContinueWithBooking;
